import {
  SHOW_JSON_COMPARE_MODAL,
  SHOW_JSON_COMPARE_MODAL_HIDE,
  CLEAR_REDUX
} from "Redux/actionTypes";

const INIT_STATE = {
  openModal: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {

    case SHOW_JSON_COMPARE_MODAL:
      return { ...state, openModal: true };

    case SHOW_JSON_COMPARE_MODAL_HIDE:
      return { ...state, openModal: false };

    case CLEAR_REDUX:
      return ["","SHOW_JSON_COMPARE_MODAL"].includes(action.payload.option)
        ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
        : { ...state }
        
    default:
      return state;
  }
};
